define((require) => {
    "use strict";

    var Backbone        = require("backbone"),
        ProjectModel    = require("ui/editor/project/ProjectModel"),
        RestApi         = require("shared/services/RestApi");

    /**
     * A collection of <tt>ProjectModel</tt>'s.
     *
     * @see ProjectModel
     *
     * @class ProjectCollection
     */
    return Backbone.Collection.extend({

        model: ProjectModel,

        url: function() {
            return RestApi.pathToCollection(RestApi.Collections.PROJECTS);
        },

        byExperienceId: function(experienceId) {
            return this.find((project) => {
                return project.containsExperience(experienceId);
            });
        },

        /**
         * @return {ProjectModel}
         */
        byExperience: function(experience) {
            return this.byExperienceId(experience.get("id"));
        },

        /**
         * @return {ProjectModel}
         */
        byGroupId: function(groupId) {
            return this.find((project) => {
                return project.containsGroup(groupId);
            });
        },

        byGroup: function(group) {
            return this.byGroupId(group.get("id"));
        },

        /**
         * @return {ProjectModel[]}
         */
        byImage: function(image) {
            return this.filter((project) => {
                return project.containsImage(image.get("id"));
            });
        },

        containsExperience: function(experience) {
            return this.byExperience(experience) !== undefined;
        },

        byChannel: function(channel) {
            return this.filter((project) => {
                return project.containsChannel(channel.get("id"));
            });
        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/editor/project/ProjectCollection.js